import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'memoize',
    standalone: false,
})
export class MemoizePipe implements PipeTransform {
    private cache = new Map<string, unknown>();
    private readonly maxSize = 1000;

    public transform<TArgs extends unknown[], TResult>(fn: (...args: TArgs) => TResult, ...args: TArgs): TResult {
        const key = JSON.stringify(args);
        if (this.cache.has(key)) {
            const cachedResult = this.cache.get(key) as TResult;
            this.cache.delete(key);
            this.cache.set(key, cachedResult);
            return cachedResult;
        }

        const result = fn(...args);
        this.cache.set(key, result);
        if (this.cache.size > this.maxSize) {
            const firstKey = this.cache.keys().next().value;
            this.cache.delete(firstKey);
        }
        return result;
    }
}
